var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShareButtonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-3-3h22v22H-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14 0a2 2 0 1 1-1.322 3.5L3.985 7.753a2.02 2.02 0 0 1 0 .495l8.693 4.252a2 2 0 1 1-.55.798L3.64 9.143a2 2 0 1 1 0-2.288l8.486-4.152A2 2 0 0 1 14 0z"
}))));
export default SvgShareButtonIcon;